/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';

/**
 * 
 * @export
 * @interface GetAttributes200Response
 */
export interface GetAttributes200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetAttributes200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetAttributes200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * Attributes divided into named buckets. Bucket names are top level keys; attributes are values. Attributes consist of key-value pairs. Attribute names (keys) may be at most 70 bytes long. Attribute values must be JSON-serializable and are limited to 64KiB.
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof GetAttributes200Response
     */
    result?: { [key: string]: { [key: string]: any; }; };
}

/**
 * Check if a given object implements the GetAttributes200Response interface.
 */
export function instanceOfGetAttributes200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetAttributes200ResponseFromJSON(json: any): GetAttributes200Response {
    return GetAttributes200ResponseFromJSONTyped(json, false);
}

export function GetAttributes200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAttributes200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function GetAttributes200ResponseToJSON(value?: GetAttributes200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': value.result,
    };
}

